import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LayerPopup from '../components/LayerPopup';
import PasskeyCreateBtn from '../components/PasskeyCreateBtn';
import QrBtnEmail from '../components/QrBtnEmail';
import LogoutBtn2 from '../components/LogoutBtn2';

const EmailRegisterPasskeys = () => {
    // 이메일용 qr
    const locationPathname = location.search
    const [parms, setParms] = useState('')
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState(null)
    const [activeWindow, setActiveWindow] = useState(false)
    const [userId, setUserId] = useState('')
    const userAgent = window.navigator.userAgent.toLowerCase();

    const withdraw = () => {
        axios.post(`/webauthn2/users/withdraw`).then((res) => {
            if (res.data.code !== 0) {
                const message = errorCode(res.data.code)
                setErrorMessage(message)
                return
            } else {
                navigate('/')
            }
        })
    }

    const errMsgQrBtn = (e) => {
        setErrorMessage(e)

    }

    useEffect(() => {
        setParms(locationPathname)
        const userId = locationPathname.split('&id=')
        setUserId(userId[1])
        if (userAgent.indexOf('windows') > -1) {
            // 윈도우 환경                   
            setActiveWindow(true)

        } else {
            setActiveWindow(false)
        }

    }, [locationPathname])



    return (
        <>

            <div className='passkey-container welcome-container dd'>
                {/* ?bj = 회원가입페이지에서 넘어온 경우 */}
                {parms === '?bj' ? (
                    <>
                        <h1 className='title'>Welcome</h1>
                        <p className='summary'>가입되었습니다.<br /> 디바이스가 Passkey 인증을 지원합니다.<br />
                            Passkey 등록을 통해 편리하고 보안이 강화된 인증을 수행할 수 있습니다.
                        </p>

                    </>
                ) : (
                    <>
                        <h1 className='title'>Sign In</h1>
                        {parms === '?noRegisterpasskey' ? (
                            <p className='summary'>패스키가 등록 되어있지 않습니다.<br />
                                Passkey 등록을 통해 편리하고 보안이 강화된 인증을 수행할 수 있습니다.
                            </p>
                        ) : (
                            <p className='summary'>디바이스가 Passkey 인증을 지원합니다.<br />
                                Passkey 등록을 통해 편리하고 보안이 강화된 인증을 수행할 수 있습니다.
                            </p>
                        )}

                    </>
                )
                }
                {activeWindow ? (
                    <>
                        <QrBtnEmail type="register" _id={userId} errMsgQrBtn={errMsgQrBtn} />
                    </>
                ) : (
                    <>
                        <PasskeyCreateBtn errMsgQrBtn={errMsgQrBtn} />
                    </>
                )}


                <LogoutBtn2 />
                <button onClick={() => withdraw()} className='email-withdraw'>회원탈퇴</button>
            </div >
            {errorMessage && <LayerPopup text={errorMessage} onClose={() => setErrorMessage(null)}></LayerPopup>}
        </>
    );
};

export default EmailRegisterPasskeys;